import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**/
import { LoginService } from './login.service';
import Swal from 'sweetalert2';

@Injectable({
	providedIn: 'root'
})
export class UtilsService {

	APIKEY:string = environment.API_KEY;
	APIURL:string = environment.API_URL;
	IDDISPOSITIVO:string = null;
	token:string = null;





	constructor(
		private http:HttpClient,
		private router:Router,
		private loginService:LoginService,
		private modalService: NgbModal
		) {
	}

	getSport(deporte:string):string{
		let res:string = "";
		switch(deporte){
			case 'BASQUETBOL':
				res = 'basquetbol';
				break;
			case 'VOLEIBOL':
				res = 'voleibol';
				break;
			default:
				res = 'futbol';
				break;
		}

		return res;

	}



	/*HELPERS*/
	// public async cargarToken() {
	// 	this.token = await localStorage.getItem('pf-token') || null;
	// 	if(!this.token){
	// 		let timerInterval;
	// 		Swal.fire({
	// 			allowOutsideClick: false,
	// 			title: 'ERROR EN VALIDACIÓN DE CREDENCIALES',
	// 			html: 'La sesión se cerrará en <b></b> milisegundos.',
	// 			timer: 3000,
	// 			timerProgressBar: true,
	// 			onBeforeOpen: () => {
	// 				Swal.showLoading()
	// 				timerInterval = setInterval(() => {
	// 					const content = Swal.getContent()
	// 					if (content) {
	// 						const b = content.querySelector('b')
	// 						if (b) {
	// 							b.textContent = Swal.getTimerLeft().toString();
	// 						}
	// 					}
	// 				}, 100)
	// 			},
	// 			onClose: async () => {
	// 				this.router.navigateByUrl('/login');
	// 				this.modalService.dismissAll();
	// 				clearInterval(timerInterval);
	// 			}
	// 		})
	// 	}

	// 	return this.token;
	// }

	public async cargarToken() {
		this.token = await localStorage.getItem('pf-token') || null;
		if(!this.token){
			let timerInterval;
			Swal.fire({
				allowOutsideClick: false,
				title: 'ERROR EN VALIDACIÓN DE CREDENCIALES',
				html: 'La sesión se cerrará en <b></b> milisegundos.',
				timer: 3000,
				timerProgressBar: true,
				willOpen: () => {
					Swal.showLoading()
					timerInterval = setInterval(() => {
						const content = Swal.getHtmlContainer()
						if (content) {
							const b = content.querySelector('b')
							if (b) {
								b.textContent = Swal.getTimerLeft().toString();
							}
						}
					}, 100)
				},
				didClose: async () => {
					this.router.navigateByUrl('/login');
					this.modalService.dismissAll();
					clearInterval(timerInterval);
				}
			})
		}

		return this.token;
	}

	public async cargarDispositivo() {


		this.IDDISPOSITIVO = await localStorage.getItem('idp') || null;

		// if(!this.token){
		if(!this.IDDISPOSITIVO){

			let timerInterval;


			Swal.fire({
				allowOutsideClick: false,
				title: 'ERROR EN VALIDACIÓN DE CREDENCIALES',
				html: 'La sesión se cerrará en <b></b> milisegundos.',
				timer: 3000,
				timerProgressBar: true,
				willOpen: () => {
					Swal.showLoading()
					timerInterval = setInterval(() => {
						const content = Swal.getHtmlContainer()
						//Swal.getContent()
						if (content) {
							const b = content.querySelector('b')
							if (b) {
								b.textContent = Swal.getTimerLeft().toString();
							}
						}
					}, 100)
				},
				didClose: async () => {
					await localStorage.removeItem('pf-token');
					this.router.navigateByUrl('/login');
					this.modalService.dismissAll();
					clearInterval(timerInterval);
				}
			
			})


			// Swal.fire({
			// 	allowOutsideClick: false,
			// 	title: 'ERROR EN VALIDACIÓN DE CREDENCIALES',
			// 	html: 'La sesión se cerrará en <b></b> milisegundos.',
			// 	timer: 3000,
			// 	timerProgressBar: true,
			// 	onBeforeOpen: () => {
			// 		Swal.showLoading()
			// 		timerInterval = setInterval(() => {
			// 			const content = Swal.getContent()
			// 			if (content) {
			// 				const b = content.querySelector('b')
			// 				if (b) {
			// 					b.textContent = Swal.getTimerLeft().toString();
			// 				}
			// 			}
			// 		}, 100)
			// 	},
			// 	onClose: async () => {
			// 		await localStorage.removeItem('pf-token');
			// 		this.router.navigateByUrl('/login');
			// 		this.modalService.dismissAll();
			// 		clearInterval(timerInterval);
			// 	}
			// })

		}


		return this.IDDISPOSITIVO;;
	}

	// public async validarErrorQueryAPI(err){
	// 		console.error(err);

	// 		if(err.error.msg){

	// 			switch (err.error.msg) {
	// 				case "FORBBIDEN_TOKEN":
	// 				case "TOKEN_NOT_EXISTS":
	// 				case "BAD_TOKEN":
	// 				case "MISSING_TOKEN":
	// 				case "EXPIRED_TOKEN":
	// 					let timerInterval
	// 					Swal.fire({
	// 						allowOutsideClick: false,
	// 						title: 'ERROR AL VALIDAR TOKEN',
	// 						html: 'La sesión se cerrará en <b></b> milliseconds.',
	// 						timer: 3000,
	// 						timerProgressBar: true,
	// 						onBeforeOpen: () => {
	// 							Swal.showLoading()
	// 							timerInterval = setInterval(() => {
	// 								const content = Swal.getContent()
	// 								if (content) {
	// 									const b = content.querySelector('b')
	// 									if (b) {
	// 										b.textContent = Swal.getTimerLeft().toString();
	// 									}
	// 								}
	// 							}, 100)
	// 						},
	// 						onClose: async () => {
	// 							await localStorage.removeItem('pf-token');
	// 							this.router.navigateByUrl('/login');
	// 							clearInterval(timerInterval);
	// 						}
	// 					});
	// 					return {errortoken: true, msg: 'TOKEN_ERROR'}
	// 					break;
	// 				case "INVALID_APIKEY":
	// 					let timerInterval_
	// 					Swal.fire({
	// 						allowOutsideClick: false,
	// 						title: 'ERROR AL VALIDAR TOKEN',
	// 						html: 'La sesión se cerrará en <b></b> milliseconds.',
	// 						timer: 3000,
	// 						timerProgressBar: true,
	// 						onBeforeOpen: () => {
	// 							Swal.showLoading()
	// 							timerInterval_ = setInterval(() => {
	// 								const content = Swal.getContent()
	// 								if (content) {
	// 									const b = content.querySelector('b')
	// 									if (b) {
	// 										b.textContent = Swal.getTimerLeft().toString();
	// 									}
	// 								}
	// 							}, 100)
	// 						},
	// 						onClose: async () => {
	// 							await localStorage.removeItem('pf-token');
	// 							await localStorage.removeItem('idp');
	// 							this.router.navigateByUrl('/login');
	// 							clearInterval(timerInterval_);
	// 						}
	// 					});
	// 					return {errortoken: true, msg: 'CONFIG_KEY_ERROR'}
	// 					break;
	// 				default:
	// 					return {errortoken: false, msg: err.error.msg}
	// 					break;
	// 			}

	// 		}else{
	// 			return {errortoken: false, msg: 'ERROR_GENERAL'}
	// 		}
	// }

	public async validarErrorQueryAPI(err){
		console.error(err);

		if(err.error.msg){

			switch (err.error.msg) {
				case "FORBBIDEN_TOKEN":
				case "TOKEN_NOT_EXISTS":
				case "BAD_TOKEN":
				case "MISSING_TOKEN":
				case "EXPIRED_TOKEN":
					let timerInterval
					Swal.fire({
						allowOutsideClick: false,
						title: 'ERROR AL VALIDAR TOKEN',
						html: 'La sesión se cerrará en <b></b> milliseconds.',
						timer: 3000,
						timerProgressBar: true,
						willOpen: () => {
							Swal.showLoading()
							timerInterval = setInterval(() => {
								const content = Swal.getHtmlContainer()
								if (content) {
									const b = content.querySelector('b')
									if (b) {
										b.textContent = Swal.getTimerLeft().toString();
									}
								}
							}, 100)
						},
						didClose: async () => {
							await localStorage.removeItem('pf-token');
							this.router.navigateByUrl('/login');
							clearInterval(timerInterval);
						}
					});
					return {errortoken: true, msg: 'TOKEN_ERROR'}
					break;
				case "INVALID_APIKEY":
					let timerInterval_
					Swal.fire({
						allowOutsideClick: false,
						title: 'ERROR AL VALIDAR TOKEN',
						html: 'La sesión se cerrará en <b></b> milliseconds.',
						timer: 3000,
						timerProgressBar: true,
						willOpen: () => {
							Swal.showLoading()
							timerInterval_ = setInterval(() => {
								const content = Swal.getHtmlContainer()
								if (content) {
									const b = content.querySelector('b')
									if (b) {
										b.textContent = Swal.getTimerLeft().toString();
									}
								}
							}, 100)
						},
						didClose: async () => {
							await localStorage.removeItem('pf-token');
							await localStorage.removeItem('idp');
							this.router.navigateByUrl('/login');
							clearInterval(timerInterval_);
						}
					});
					return {errortoken: true, msg: 'CONFIG_KEY_ERROR'}
					break;
				default:
					return {errortoken: false, msg: err.error.msg}
					break;
			}

		}else{
			return {errortoken: false, msg: 'ERROR_GENERAL'}
		}
}

	// public async logoutByTokenError(errormsg){

	// 	if(errormsg){
	// 		if (errormsg === 'BAD_TOKEN' || errormsg === 'TOKEN_EXPIRED' || errormsg === 'USER_NOT_AVAILABLE'){
	// 			let timerInterval
	// 			Swal.fire({
	// 				allowOutsideClick: false,
	// 				title: 'Error en valiación del token!',
	// 				html: 'La sesión se cerrará en <b></b> milliseconds.',
	// 				timer: 3000,
	// 				timerProgressBar: true,
	// 				onBeforeOpen: () => {
	// 					Swal.showLoading()
	// 					timerInterval = setInterval(() => {
	// 						const content = Swal.getContent()
	// 						if (content) {
	// 							const b = content.querySelector('b')
	// 							if (b) {
	// 								b.textContent = Swal.getTimerLeft().toString();
	// 							}
	// 						}
	// 					}, 100)
	// 				},
	// 				onClose: async () => {
	// 					await localStorage.removeItem('pf-token');
	// 					this.router.navigateByUrl('/login');
	// 					clearInterval(timerInterval);
	// 				}
	// 			});
	// 		}
	// 	}

	// }


	public async logoutByTokenError(errormsg){

		if(errormsg){
			if (errormsg === 'BAD_TOKEN' || errormsg === 'TOKEN_EXPIRED' || errormsg === 'USER_NOT_AVAILABLE'){
				let timerInterval
				Swal.fire({
					allowOutsideClick: false,
					title: 'Error en valiación del token!',
					html: 'La sesión se cerrará en <b></b> milliseconds.',
					timer: 3000,
					timerProgressBar: true,
					willOpen: () => {
						Swal.showLoading()
						timerInterval = setInterval(() => {
							const content = Swal.getHtmlContainer()
							if (content) {
								const b = content.querySelector('b')
								if (b) {
									b.textContent = Swal.getTimerLeft().toString();
								}
							}
						}, 100)
					},
					didClose: async () => {
						await localStorage.removeItem('pf-token');
						this.router.navigateByUrl('/login');
						clearInterval(timerInterval);
					}
				});
			}
		}

	}



	public valemail(data):boolean{
		const EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
		if(data.match(EMAIL_REGEX)){
			return true;
		}else{
			console.error('INVALID_EMAIL');
			return false;
		}
	}

	obtenerFechabyModel(model):string{
		let year = model.year.toString();
		let month = model.month.toString();
		let day = model.day.toString();


		if (month.length === 1){
			month = `0${month}`;
		}

		if (day.length === 1){
			day = `0${day}`;
		}

		let fecha:string = year + '-' + month + '-' +day;


		return fecha;
	}

	public valdata(data, type):boolean{
		const b = /^\d+$/;
		switch (type) {
			case "int":
				return b.test(data);
				break;
			case "intgt0":
				if(b.test(data)){
					return ((data * 1) > 0) ? true : false;
				}else{
					return false;
				}
				break;
			case "datemodel":
				let year = data.year;
				let month = data.month;
				let day = data.day;

				if(year > 2000){

					if(month > 0 && month < 13){

						if(day > 0 && day < 32){
							return true;
						}else{
							return false;
						}

					}else{
						return false;
					}

				}else{
					return false;
				}
				break;
			case "email":
				const EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
				if(data.match(EMAIL_REGEX)) return true;
				else return false;
				break;
			default:
				return false;
				break;
		}
	}


	public obtenerIdDispositivo_main(from:string = ''){


		return new Promise( async (resolve, reject) => {
			this.IDDISPOSITIVO = await localStorage.getItem('idp') || null;

			if(!this.IDDISPOSITIVO){
				const URL:string = this.APIURL + 'opciones/dispositivos';
				const headers = new HttpHeaders({'Ls-Apikey': this.APIKEY})
				let body = new FormData;
				

				this.http.post(URL, {}, { headers}).subscribe( 
					
					(res:any) => {
						
						if(!res.error){
							this.IDDISPOSITIVO = res.msg;
							localStorage.setItem('idp', res.msg);
							return resolve(this.IDDISPOSITIVO);
						}else{
							reject(res.msg);
						}
					}, 
					(err:any) => {
						if(err.error.msg){
							reject(err.error.msg);
						}else{
							reject(err);
						}
				})
			}else{
				resolve(this.IDDISPOSITIVO)
			}
		})
	}



	// public validarErrorAPI(err):boolean{

	// }

	public validarDataRequieredForAPI(token, dispositivo):Promise<boolean>{


		return new Promise( async (resolve) => {
			if(token && dispositivo){
				resolve(true)
			}else{
				resolve(false)
			}
		})


	}


	/*=====================================
	=            RUTAS PREVIAS            =
	=====================================*/

	public async guardarRutaPrevia(ruta){
		await localStorage.setItem('pf-rutaprev', ruta);
	}

	public async obtenerRutaPrevia(){
		return await localStorage.getItem('pf-rutaprev') || null;

	}

	public async limpiarRutaPrevia(){
		await localStorage.removeItem('pf-rutaprev');
	}


	/*===============================
	=            STORAGE            =
	===============================*/

	/**
		CLAVES
	"Vista de partidos"
	pl-vpartidos: list | card
	**/

	public async guardarStorage(clave, valor){
		await localStorage.setItem(clave, valor);
	}

	public async obtenerStorage(clave){
		return await localStorage.getItem(clave) || null;

	}

	public async limpiarStorage(clave){
		await localStorage.removeItem(clave);
	}
	
	
	
	
	
	
	


	/*================================================
	=            INFORMACIÓN DE SECCIONES            =
	================================================*/
	INFOSECCIONES:any = {
		liga: {
			datosgenerales: `
				<h5>Datos generales</h5>
				<p>Los datos generales son para la identificación de la liga. Estos campos no pueden estar vacíos.<p>
				<p>Solo puede haber una liga con el mismo nombre en una misma sede.</p>
				<p>El link web se genera automáticamente, con los datos del nombre de la liga y la sede.</p>

			`,
			torneos: `
				<h5>Torneos</h5>
				<p>Se muestra el listado de los torneos.<p>
				<p>La cantidad de torneos que se pueden agregar, depende del plan de la liga.</p>
				<p>Puede cambiar el plan en la sección "<b>Plan</b>".</p>

			`,
		}
	}
	
	
	










}
